import React from 'react'
import '../styles/main.css'
import Aos from 'aos'
import 'aos/dist/aos.css'
import About from './About';
import Projects from './Projects';
import Contact from './Contact'
import Footer from './Footer'
import Skill from './Skill'
import { Link } from 'react-scroll'

export default function Main() {
  React.useEffect(() => {
    Aos.init({
      once: true
    })
  }, [])

  return (
    <>
      <div className="container3">
        <div className="container2">
          <p>Hello I am</p>
          <h2>Rishabh</h2>
          <h2>Singh</h2>
          <p>A young developer with passion and determination</p>
        </div>
        <Link to='contact' spy={true} smooth={true} offset={50} duration={500}>
          <button>
            <p>Get in Touch</p>
          </button>
        </Link>
      </div>
      <div className="background">
        <About />
        <Skill />
        <Projects />
        <Contact />
        <Footer />
      </div>
    </>
  )
}
